import type { ReactNode } from 'react';

import type { HeaderProps } from '../types';

/**
 * Header component for defining column headers.
 *
 * This is a declarative/config component that returns null.
 * The header content is extracted by parseChildren and rendered
 * by TableHead.
 *
 * @example
 * ```tsx
 * <DataTable.Column id="name" accessor="name">
 *   <DataTable.Header>Name</DataTable.Header>
 * </DataTable.Column>
 * ```
 */
export const Header = (_props: HeaderProps): ReactNode => {
  // Pure declarative component - content is extracted by parseChildren
  return null;
};

Header.displayName = 'DataTable.Header';
